"use client";

const LeaderboardSkeleton: React.FC = () => {
    return (
        <div className="border-brand_stream_team w-full animate-pulse overflow-hidden rounded-xl border bg-zinc-950/80 shadow-xl">
            <div className="border-b border-zinc-700 bg-zinc-900/90 px-4 py-3 sm:px-6">
                <div className="h-4 w-40 rounded bg-zinc-700" />
            </div>
            {Array.from({ length: 6 }).map((_, index) => (
                <div
                    key={index}
                    className="grid grid-cols-[64px_1fr_auto] items-center gap-3 border-b border-zinc-800 px-4 py-3 last:border-b-0 sm:px-6"
                >
                    <div className="h-6 w-10 rounded bg-zinc-700" />
                    <div className="flex items-center gap-3">
                        <div className="h-11 w-11 rounded-full bg-zinc-700" />
                        <div className="space-y-2">
                            <div className="h-4 w-32 rounded bg-zinc-700" />
                            <div className="h-3 w-14 rounded bg-zinc-700" />
                        </div>
                    </div>
                    <div className="h-6 w-14 rounded bg-zinc-700" />
                </div>
            ))}
        </div>
    );
};

export default LeaderboardSkeleton;
